import React from 'react';

export default function Footer() {
  return (
    <footer className="w-full px-4 py-3" style={{ backgroundColor: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
      <p className="text-center text-xs leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
        Les prévisions basées sur Open-Meteo sont indicatives et n&apos;engagent pas l&apos;auteur. Le pilote reste seul responsable.
      </p>
      <p className="text-center text-xs mt-1" style={{ color: 'var(--text-muted)' }}>
        Application développée par Pascal Mourgues · SoarCast v1.0.21 bis
      </p>
    </footer>
  );
}
